<template>
  <v-card flat class="px-3">
    <v-col
      @click="handleBack"
      cols="12"
      class="body-bold-smaller btnTextType1--text py-0"
    >
      <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
      <a type="primary" class="body-bold-smaller brand-60-base--text"
        >{{ $t('message.actions.return') }}
      </a>
    </v-col>

    <v-col class="pt-1 py-0">
      <span class="body-bold-medium">{{
        $t('message.ai.mindmap.mindmap')
      }}</span>
    </v-col>

    <v-col cols="12" class="pt-0 pb-2">
      <span class="body-regular-smaller textType6--text pageDescription">
        {{ $t('message.ai.mindmap.mindMapDescription') }}
        <a target="_blank" type="secondary" :href="handleKnowMore">
          <span>
            {{ $t('message.embedModal.knowMore') }}
          </span>
          <v-icon size="12">mdi-open-in-new</v-icon>
        </a>
      </span>
    </v-col>
    <v-row class="d-flex">
      <v-container :class="{ 'd-none': !isLoading }">
        <v-row class="d-flex">
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width ml-3"
              type="chip"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="12">
            <v-skeleton-loader
              class="border loader-width ml-3 pr-5"
              type="image"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
      <v-col cols="12" :class="{ 'd-none': isLoading }" style="width: 100%">
        <v-col class="pt-5 py-0">
          <span class="body-bold-medium"
            >PandaAI - {{ $t('message.ai.mindmap.mindmap') }}</span
          >
        </v-col>

        <v-col cols="12" class="mt-2">
          <v-row>
            <v-col cols="9" class="pl-3">
              <p class="mb-0 body-regular-small">
                {{ $t('message.ai.mindmap.activeMindMap') }}
              </p>
              <span class="body-regular-smaller textType6--text">{{
                $t('message.ai.mindmap.activeMindMapDescription')
              }}</span>
            </v-col>
            <v-col cols="3" class="d-flex align-center justify-end">
              <v-switch
                v-model="isEnabledInPlayer"
                :disabled="preventToggleQuickly"
                @click="toggleActivation"
                class="my-0 py-0 ml-2 align-center"
                compact
                hide-details
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-col>

      <v-col
        v-if="isEnabledInPlayer"
        cols="12"
        class="mx-5 pr-5 pt-1 pa-0 pb-6"
      >
        <v-divider />
      </v-col>
      <v-col v-if="isEnabledInPlayer" class="pa-0">
        <v-col cols="12">
          <span class="body-bold-medium pl-3">{{
            $t('message.ai.mindmap.mindmapContent')
          }}</span>
        </v-col>
        <v-col cols="12" class="d-flex justify-space-between mb-3">
          <div>
            <span class="body-regular-small ml-3">{{
              $t('message.ai.mindmap.viewMindMap')
            }}</span>
          </div>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span
                  @click="openEditMindMapModal"
                  class="mindMapBtn mr-3"
                  v-on="on"
                  v-bind="attrs"
                >
                  <span>
                    <v-icon class="iconBtn" size="16">panda-edit</v-icon>
                  </span>
                </span>
              </template>
              <span>{{ $t('message.actions.edit') }} </span>
            </v-tooltip>

            <base-btn
              @click="openMindMapModal"
              size="small"
              outlined
              type="tertiary"
            >
              {{ $t('message.actions.open') }}
            </base-btn>
          </div>
        </v-col>
      </v-col>

      <MindmapEditModal :videoId="video.id"></MindmapEditModal>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
//import Panzoom from 'panzoom'
import playerApi from '@/services/playerApi.js'
import videosApi from '@/services/videosApi.js'
import linkHelper from '@/utils/linkHelper.mixin.js'
import { CONFIG_URL } from '@/config/envs.js'
import MindmapEditModal from './MindmapEditModal.vue'
import Storage from '@/utils/Storage'
import i18n from '@/translations/lang'

export default {
  name: 'VideoPlayerMindMap',
  mixins: [linkHelper],
  components: { MindmapEditModal },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      preventToggleQuickly: false,
      mermaidScriptLoaded: false,
      mermaid: '',
      mermaidDiagram: '',
      isEnabledInPlayer: false,
      mindMap: '',
      videoConfig: {},
      isLoading: true,
      mindmapString: '',
      componentKey: 1,
    }
  },
  created() {
    this.checkEnabledItems()
  },
  mounted() {
    // this.handleData()
    this.$root.$on('handleDownloadMindMap', () => {
      this.handleDownloadMindMap()
    })
    // this.$root.$on('renderDiagram', async (myConvertedModel) => {
    //   this.mermaidScriptLoaded = false
    //   this.mindmap = myConvertedModel
    //   this.componentKey += 1
    //   await this.renderDiagram()
    // })
  },
  computed: {
    ...mapState({
      hasData: (state) => state.video.aiWorkFlow?.data,
      video: (state) => state.video.video,
    }),
    locale() {
      return this.$i18next.resolvedLanguage
    },
    handleKnowMore() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/panda-ia-mind-map-1b8vq1e/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/panda-ai-mapa-mental-1fo8n3g/'
      }
      return 'https://help.pandavideo.com/pt-br/article/panda-ia-mapa-mental-1q9ca0i/'
    },
    canShowDownloadBtn() {
      if (this.video?.config?.ai?.pdf_generated) {
        return this.video?.config?.ai?.pdf_generated
      }
      return false
    },
  },
  methods: {
    ...mapMutations('video', ['UPDATE_AI_VIDEO_CONFIG', 'UPDATE_VIDEO_CONFIG']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('video', ['handleFetchAiWorkFlowData']),
    handleDownloadMindMap() {
      const url = `${CONFIG_URL}/${this.video.pullzone_name}/${this.video.video_external_id}/mindmap.pdf`
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const file = window.URL.createObjectURL(blob)
          const tempDownloadTag = document.createElement('a')
          tempDownloadTag.href = file
          tempDownloadTag.download = 'mindmap.pdf'
          document.body.appendChild(tempDownloadTag)
          tempDownloadTag.click()
          tempDownloadTag.remove()
        })
        .catch((err) => {
          console.log(err)
        })
    },

    async toggleActivation() {
      this.preventToggleQuickly = true
      this.videoConfig['mindmap'] = this.isEnabledInPlayer
      await playerApi.updateAiVideoConfig(this.video.id, this.videoConfig)
      this.preventToggleQuickly = false
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.ai.mindmap.savedMindmap'),
        type: 'success',
      })
    },
    async checkEnabledItems() {
      try {
        const {
          data: { config },
        } = await videosApi.getAVideo(this.video.id)
        this.UPDATE_VIDEO_CONFIG(config)
        this.isEnabledInPlayer = ((config || {}).ai || {}).mindmap || false
        this.videoConfig = (config || {}).ai || {}
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    openEditMindMapModal() {
      this.$root.$emit('openEditMindMapModal')
    },
    openMindMapModal() {
      this.$root.$emit('openMindMapModal')
    },
    addMindmapToLocalStorage(val) {
      const key = 'mindmapString'
      Storage.setItem(key, val)
    },
  },
}
</script>

<style lang="scss" scoped>
#mermaid-container {
  display: flex;
  justify-self: center;
  align-items: baseline;
  width: auto;
  height: auto;
  // width: 100%;
  // height: 100%;
}

.mindMapBtn {
  padding: 3px 4px 4px 4px;
}

.mindMapBtn:hover {
  border-radius: var(--spacing-02, 4px);
  background: varFigma(neutral-95-lightest);
  cursor: pointer;
}

.scroll-container {
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  cursor: grab;
  // width: 450px;
}

.row-container {
  display: flex;
  width: 100%;
  margin-right: 15px;
}
.flexible-div {
  flex-grow: 1;
}

.loader-width {
  width: 100%;
}

.scroll-container:active {
  cursor: grabbing;
}

.display-mindmap {
  visibility: hidden;
}

.pageDescription {
  color: varFigma(neutral-40-light);
}
</style>
